/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ events: NonNullable<unknown>, files: NonNullable<unknown> }} Artifactpackprogressdonenoanswers5Inputs */

const en_artifactpackprogressdonenoanswers5 = /** @type {(inputs: Artifactpackprogressdonenoanswers5Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.events} timeline events · ${i?.files} documents organised. The hard part's done.`)
};

const pt_artifactpackprogressdonenoanswers5 = /** @type {(inputs: Artifactpackprogressdonenoanswers5Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.events} eventos na cronologia · ${i?.files} documentos organizados. A parte difícil está feita.`)
};

/**
* | output |
* | --- |
* | "{events} timeline events · {files} documents organised. The hard part's done." |
*
* @param {Artifactpackprogressdonenoanswers5Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpackprogressdonenoanswers5 = /** @type {((inputs: Artifactpackprogressdonenoanswers5Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpackprogressdonenoanswers5Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpackprogressdonenoanswers5(inputs)
	return pt_artifactpackprogressdonenoanswers5(inputs)
});
export { artifactpackprogressdonenoanswers5 as "artifactPackProgressDoneNoAnswers" }